"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.track = exports.config = exports.trackPageview = exports.load = void 0;
const interpret = (command, arg1) => {
    window.panelbear =
        window.panelbear ||
            function () {
                window.panelbearQ = window.panelbearQ || [];
                window.panelbearQ.push(arguments);
            };
    try {
        window.panelbear(command, arg1);
    }
    catch (e) {
        // tslint:disable-next-line:no-console
        console.warn('There was an error while executing a Panelbear command', e);
    }
};
const load = (site, config) => {
    var _a;
    const tracker = document.createElement('script');
    tracker.async = true;
    tracker.src = `${(_a = config === null || config === void 0 ? void 0 : config.scriptSrc) !== null && _a !== void 0 ? _a : 'https://cdn.panelbear.com/analytics.js'}?site=${site}`;
    document.head.appendChild(tracker);
    interpret('config', Object.assign({ site: site, 
        // Disable auto-track on the JS client. Most projects using this library need
        // more control over the event handlers.
        autoTrack: false }, config));
};
exports.load = load;
const trackPageview = () => {
    interpret('trackPageview');
};
exports.trackPageview = trackPageview;
const config = (config) => {
    interpret('config', config);
};
exports.config = config;
const track = (eventName) => {
    interpret('track', eventName);
};
exports.track = track;
//# sourceMappingURL=index.js.map